export class ActivarEvaluacion{
    ID_evaluado:number;
    motivoInactivacion:string;
    ID_evaluador:number;
}